import React from "react";
import PropTypes from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import { UserFallbackIcon } from "../../Svgs/user-fallback-icon";
import "./author-image.m.css";

const AuthorImage = ({ author, template = "" }) => {
  const { "avatar-url": avatarUrl, "avatar-s3-key": avatarS3Key, name } = author;
  const templateStyle = template === "smallCircle" ? "small-circle" : template === "square" ? "square" : "";
  return (
    <div styleName={`author-image ${templateStyle}`}>
      <figure className="arrow-component" styleName="wrapper-comp">
        {avatarS3Key ? (
          <ResponsiveImage
            slug={avatarS3Key}
            alt={name}
            imgParams={{ auto: ["format", "compress"] }}
            defaultWidth={480}
            widths={[250, 480, 640]}
            aspectRatio={[1, 1]}
          />
        ) : avatarUrl ? (
          <img src={avatarUrl} />
        ) : (
          <UserFallbackIcon />
        )}
      </figure>
    </div>
  );
};

AuthorImage.propTypes = {
  author: PropTypes.shape({
    "avatar-url": PropTypes.string,
    "avatar-s3-key": PropTypes.string,
    name: PropTypes.string
  }),
  template: PropTypes.string
};

export default AuthorImage;
